import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/5 bg-[#02060D] pt-20 pb-10" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="h-3.5 w-3.5 rounded-full bg-gradient-to-tr from-[#3B82F6] to-[#F59E0B]" />
              <span className="text-lg font-semibold tracking-tight">Jorviko</span>
            </div>
            <p className="mt-5 max-w-sm text-white/45 leading-relaxed">
              {t({
                en: "Software. AI. Automation. We help businesses build better digital products, automate manual work and modernise how they operate.",
                no: "Programvare. AI. Automatisering. Vi hjelper bedrifter med å bygge bedre digitale produkter, automatisere manuelt arbeid og modernisere måten de drives på.",
              })}
            </p>
            <p className="mt-6 font-mono text-xs tracking-widest text-white/30">
              {t({ en: "OSLO · NORWAY", no: "OSLO · NORGE" })}
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs tracking-[0.2em] uppercase text-white/40">
              {t({ en: "Navigate", no: "Naviger" })}
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
                    className="text-white/60 hover:text-white transition-colors duration-300"
                  >
                    {t(item.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs tracking-[0.2em] uppercase text-white/40">
              {t({ en: "Get in touch", no: "Ta kontakt" })}
            </h4>
            <a href="mailto:hello@jorviko.no" className="mt-5 block text-white/60 hover:text-white transition-colors">hello@jorviko.no</a>
            <Link to="/contact" data-testid="footer-cta" className="mt-6 inline-flex items-center gap-1.5 rounded-full bg-white/5 border border-white/10 px-5 py-2.5 text-sm text-white hover:bg-white/10 transition-all duration-300">
              {t({ en: "Discuss Your Project", no: "Diskuter ditt prosjekt" })}
            </Link>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/30 font-mono tracking-wider">
          <span>© {new Date().getFullYear()} JORVIKO</span>
          <span>SOFTWARE · AI · AUTOMATION</span>
        </div>
      </div>
    </footer>
  );
};
